import { Col, Grid, Message, Row, toaster } from 'rsuite';
import { useCallback, useState } from 'react';
import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import { ContainerLogoTitle, ContainerSize } from './Cadastro/styles';
import { CustomButton } from '../../../components/CustomButton';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { CustomInput } from '../../../components/CustomInput';
import { Label } from '../../../components/Label';
import { Tamanho } from './Tamanho';
import { toastSuccess } from '../../../toasts';

const Tamanhos = ({ idGrupo, tamanhos, handleSetTamanhos }) => {
  const { id_empresa } = useAuth();
  const [addTamanho, setAddTamanho] = useState('');
  const { theme } = useCustomTheme();

  function handleAddTamanho() {
    if (!addTamanho) {
      toaster.push(
        <Message showIcon type="error">
          Preencha todos os campos
        </Message>,
      );
      return;
    }

    const sizeDescription = String(addTamanho);

    setAddTamanho('');

    if (idGrupo) {
      handleCreateSubmit(sizeDescription);
      return;
    }

    let newTamanho = {
      Id: tamanhos.length + 1,
      Descricao: sizeDescription,
      QtdSabores: 0,
      QtdPedacos: 0,
      Ativo: true,
    };

    handleSetTamanhos(() => {
      let newState = [...tamanhos];
      newState.push(newTamanho);
      return newState;
    });
  }

  const handleCreateSubmit = useCallback(
    async (Description) => {
      try {
        const requestData = {
          IdEmpresa: id_empresa,
          Grupo: idGrupo,
          TipoPizza: false,
          QtdSabores: 0,
          QtdPedacos: 0,
          Descricao: Description,
        };

        const { data } = await api.post('tamanho/criar', requestData);

        handleSetTamanhos(() => [...tamanhos, data]);

        setAddTamanho('');

        toastSuccess("Tamanho cadastrado");
      } catch (err) {
        console.log(err);
      }
    },
    [addTamanho, handleSetTamanhos],
  );

  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      const newItems = Array.from(tamanhos);
      const [reorderedItem] = newItems.splice(dragIndex, 1);
      newItems.splice(hoverIndex, 0, reorderedItem);

      handleSetTamanhos(newItems);
    },
    [tamanhos],
  );

  return (
    <>
      <ContainerLogoTitle
        style={{
          marginBottom: 10,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          gap: 10,
        }}
      >
        <Col xs={24} style={{ marginTop: 6 }}>
          <Label>Nome do tamanho</Label>
          <CustomInput
            placeholder="Tamanho ex: Pequena"
            value={addTamanho}
            onChange={setAddTamanho}
          />
        </Col>
        <CustomButton
          appearance="primary"
          style={{ paddingLeft: '20px', paddingRight: '20px' }}
          onClick={handleAddTamanho}
        >
          Cadastrar
        </CustomButton>
      </ContainerLogoTitle>
      <ContainerSize
        style={{
          paddingBottom: tamanhos.length > 0 ? 0 : '50px',
          maxHeight: '60vh',
          overflowY: 'auto',
        }}
      >
        <Grid bordered style={{ marginTop: 4, width: '100%' }}>
          <Row
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: 'transparent',
              padding: '6px 12px',
              borderRadius: '10px',
              marginTop: '12px',
              marginBottom: '6px',
            }}
          >
            <Col
              xs={20}
              style={{
                color: theme.colors.text,
              }}
            >
              Descricao
            </Col>
            <Col
              xs={3}
              style={{
                color: theme.colors.text,
              }}
            >
              Status
            </Col>
            <Col
              xs={1}
              style={{
                color: theme.colors.text,
              }}
            ></Col>
          </Row>
          {tamanhos.map((item, index) => (
            <Tamanho
              key={item.Id}
              item={item}
              handleSetTamanhos={handleSetTamanhos}
              tamanhos={tamanhos}
              moveCard={moveCard}
              index={index}
            />
          ))}
        </Grid>
      </ContainerSize>
    </>
  );
};

export default Tamanhos;
